<script lang="ts">
/**
 * What a person typed, exactly as they typed it, with each web address in it a link (ZhLink) that opens in a new
 * tab. No Markdown is read (lib/markdown.ts linkTyped): the text is only ever text, and keeps its own line breaks
 * where its parent keeps whitespace.
 */
import { computed, defineComponent, h } from 'vue'
import { linkTyped } from '../lib/markdown'
import ZhLink from './ZhLink.vue'

export default defineComponent({
    name: 'ZhTypedText',
    props: {
        /** What the person typed. */
        text: { type: String, required: true },
    },
    setup(props) {
        const parts = computed(() => linkTyped(props.text))
        return () =>
            h(
                'span',
                parts.value.map(part =>
                    part.kind === 'link' ? h(ZhLink, { href: part.href }, () => part.href) : part.text,
                ),
            )
    },
})
</script>
